import React, {useState, useEffect} from "react";
import {Container, Row} from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";

import {Avatar, Button, Rate} from "antd"; // Importação do componente Rate para as estrelas
import "bootstrap/dist/css/bootstrap.css";

import {Link} from "react-router-dom";
import ApiService from "../util/ApiService";
import AuthService from "../login/AuthService";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css"; // Importando o CSS do skeleton loader
import Swal from "sweetalert2";
import "./assets/css/Notifications.css";
import LoadingScreen from "../util/LoadingScreen";
import {Modal} from "bootstrap";
import CustomPagination from "../util/CustomPagination";
import {formatDuration, intervalToDuration} from "date-fns";
import {ptBR} from "date-fns/locale";
import DutyDetailModal from "../dashboard/calender/dutyDetailModal";
import PlantaoModal from "../dashboard/calender/plantaoModal";
import PlantaoRepostModal from "../dashboard/calender/plantaoRepostModal";

// Função para traduzir a nota de avaliação
function getRating(rating) {
    switch (rating) {
        case 1:
            return "Ruim";
        case 2:
            return "Nada especial";
        case 3:
            return "Mediano";
        case 4:
            return "Muito bom";
        case 5:
            return "Excelente";
        default:
            return "Nenhum";
    }
}

const NotificationsPage = () => {
    document.title = "Notificações | Plantão Rápido";
    const [loadingPage, setLoadingPage] = useState(false);
    const [user, setUser] = useState(AuthService.getUserData());
    const [notifications, setNotifications] = useState([]);
    const [loading, setLoading] = useState(false);
    const [pagination, setPagination] = useState({current: 1, pageSize: 10, total: 0, lastPage: 0});
    const [selectedNotification, setSelectedNotification] = useState(null);
    const [hospitalRating, setHospitalRating] = useState(0); // Nota do hospital
    const [hoveredHospitalRating, setHoveredHospitalRating] = useState(0); // Avaliação durante o hover do hospital
    const [userRating, setUserRating] = useState(0); // Nota do responsável
    const [hoveredUserRating, setHoveredUserRating] = useState(0); // Avaliação durante o hover do responsável
    const [feedbackHospital, setFeedbackHospital] = useState(""); // Feedback do hospital
    const [feedbackResponsavel, setFeedbackResponsavel] = useState(""); // Feedback do responsável
    const [selectedDuty, setSelectedDuty] = useState(null);
    const [duty, setDuty] = useState([]);// Estado para o dever selecionado
    const [modalVisible, setModalVisible] = useState(false); // Estado para a visibilidade do modal
    const [showDutyModal, setShowDutyModal] = useState(false);
    const [showPlantaoRepostModal, setShowPlantaoRepostModal] = useState(false);

    const fetchNotifications = async () => {
        setLoading(true);
        try {
            const response = await ApiService.send("get", `${process.env.REACT_APP_URL_API}notification/list`, {
                pagination: pagination.pageSize,
                page: pagination.current,
                readAll: "true",
            });


            const {data, pagination: pagInfo} = ApiService.handleApiResponse(response);
            setNotifications(data || []);
            setPagination(pagInfo || {current: 1, pageSize: 10, total: 0});


        } catch (error) {
            ApiService.handleApiError(error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchNotifications();
    }, [pagination.current]);

    // Função para abrir o modal de avaliação
    const modalRatings = (notification) => {
        setHospitalRating(0);
        setUserRating(0);

        if (typeof notification.data === "string") {
            notification.data = JSON.parse(notification.data);
        }

        setSelectedNotification(notification);
        const modal = new Modal(document.getElementById("ratingsModalPage"));
        modal.show();
    };

    // Função para salvar a avaliação
    const handleSaveRatings = () => {
        setLoadingPage(true);
        ApiService.send("post", `${process.env.REACT_APP_URL_API}users/rating`, {
            notification_id: selectedNotification.id,
            duty_id: selectedNotification.id_duty,
            rated_user_id: selectedNotification.data.id_user_duty,
            rating: userRating,
            comment: feedbackResponsavel,
            rated_hospital_id: selectedNotification.data.hospital_id,
            rating_hospital: hospitalRating,
            feedback_hospital: feedbackHospital,
        })
            .then((response) => {
                // Requisição bem-sucedida
                setLoadingPage(false);
                Swal.fire({
                    title: "Sucesso!",
                    text: "Avaliação salva com sucesso!",
                    icon: "success",
                    confirmButtonText: "OK",
                });

                const modal = Modal.getInstance(document.getElementById("ratingsModalPage"));
                modal.hide();
            })
            .catch((error) => {
                setLoadingPage(false);
                Swal.fire({
                    title: "Erro!",
                    text: error.response?.data?.message || "Ocorreu um erro inesperado. Por favor, tente novamente.",
                    icon: "error",
                    confirmButtonText: "OK",
                });
            });
    };

    // Função para marcar uma única notificação como lida
    const handleSingleMarkAsRead = async (id) => {
        setLoadingPage(true);
        try {
            await ApiService.send("put", `${process.env.REACT_APP_URL_API}notification/read`, {id, was_read: true});

            // Atualiza o estado local para refletir que a notificação foi lida
            setNotifications((prevNotifications) =>
                prevNotifications.map((notification) =>
                    notification.id === id ? {...notification, was_read: 1} : notification
                )
            );
            setLoadingPage(false);
        } catch (error) {
            ApiService.handleApiError(error);
        }
    };

    // Função para marcar todas as notificações como lidas
    const handleMarkAllAsRead = async () => {
        setLoadingPage(true);
        try {
            await ApiService.send("put", `${process.env.REACT_APP_URL_API}notification/readAll`, {was_read: true});
            setNotifications(notifications.map((notification) => ({...notification, was_read: 1})));
            setLoadingPage(false);
        } catch (error) {
            ApiService.handleApiError(error);
        }
    };


    const handleDutyClick = (duty) => {
        setSelectedDuty(duty);
        setModalVisible(true);
    };

    const handleModalClose = () => {
        setModalVisible(false);
        setSelectedDuty(null);
    };

    const handlePlantaoModalClose = () => {
        setShowDutyModal(false);
    };
    const handlePlantaoRepostModalClose = () => {
        setShowPlantaoRepostModal(false);
    };

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <BreadCrumb title="Listagem" pageTitle="Notificação"/>
                    <Row>
                        {loadingPage && <LoadingScreen/>}


                        <div className="list-container mt-4">
                            {loading ? (

                                        <div className="row">
                                            <div className="col-3">
                                                <Skeleton width={90} height={90}/>
                                            </div>
                                            <div className="col-9">
                                                <Skeleton width={200}/>
                                                <p>
                                                    <Skeleton width={200}/>
                                                </p>
                                                <p className="card-text">
                                                    <Skeleton width={200}/>
                                                </p>
                                                <p className="card-text">
                                                    <Skeleton width={200}/>
                                                </p>
                                                <p className="card-text">
                                                    <Skeleton width={200}/>
                                                </p>
                                                <p className="card-text">
                                                    <Skeleton width={200}/>
                                                </p>
                                            </div>
                                        </div>

                            ) : notifications.length > 0 ? (
                                notifications.map((notification) => (
                                    <div
                                        key={notification.id}
                                        className={`duty-card shadow-sm mb-3 ${
                                            notification.was_read === 0 ? "bg-warning" : "bg-white"
                                        }`}
                                    >
                                        <div className="card-body">
                                            <div className="row">
                                                <div
                                                    className="notification-details col-12 col-md-10 col-lg-10  d-flex align-items-center">
                                                    {notification.hospital_image && (
                                                        <img
                                                            src={notification.hospital_image}
                                                            alt="Hospital"
                                                            className="hospital-image"
                                                        />
                                                    )}
                                                    <div className="ml-3 notification-body">
                                                        <span
                                                            className="mb-1 title-notification">{notification.title}</span><br/>
                                                        <span
                                                            className="details-notification">{notification.body}</span><br/>
                                                        <small className="text-muted">
                                                            {new Date(notification.created_at).toLocaleString()}
                                                        </small>
                                                    </div>
                                                </div>
                                                <div
                                                    className="notification-actions col-12 col-md-2 col-lg-2 d-flex flex-column align-items-end mt-3 mt-md-0">
                                                    {notification.was_read === 0 && (
                                                        <button type="button"
                                                            className="mb-2 btn btn-info btn-sm w-100"
                                                            onClick={() => handleSingleMarkAsRead(notification.id)}
                                                        >
                                                            <i className="fa fa-check"></i> Lido
                                                        </button>
                                                    )}
                                                    {notification.type_notification_id === 6 && (
                                                        <button
                                                            type="button"
                                                            className="w-100 btn btn-success btn-sm mb-2"
                                                            onClick={() => modalRatings(notification)}
                                                        >
                                                            <i className="fa fa-edit"></i> Avaliar
                                                        </button>
                                                    )}
                                                    {notification.type_notification_id !== 7 && (
                                                        <button type="button"
                                                            className="btn btn-primary btn-sm w-100 mb-2"
                                                            onClick={() => handleDutyClick(notification)}>

                                                            <i className="fa fa-list"></i>{" "}Detalhes
                                                        </button>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))
                            ) : (
                                <div className="alert alert-primary" role="alert">Nenhuma notificação
                                    encontrada.
                                </div>
                            )}
                        </div>
                        <CustomPagination
                            className="mt-4"
                            pagination={pagination}
                            onChange={(page) => setPagination({...pagination, current: page})}
                        />


                        {/* Modal de Avaliação */}
                        <div className="modal fade" id="ratingsModalPage" tabIndex="-1"
                             aria-labelledby="ratingsModalPageLabel" aria-hidden="true">
                            <div className="modal-dialog">
                                <div className="modal-content">
                                    {selectedNotification ? (
                                        <>
                                            <div className="modal-header bg-primary text-white">
                                                <h5 className="modal-title" id="ratingsModalLabel">
                                                    Avaliação de Plantão
                                                </h5>
                                                <button
                                                    type="button"
                                                    className="btn-close btn-close-white"
                                                    data-bs-dismiss="modal"
                                                    aria-label="Close"
                                                ></button>
                                            </div>
                                            <div className="modal-body">
                                            {selectedNotification.hospital_image && (
                                                    <div className="text-center mb-3">
                                                        <img
                                                            src={selectedNotification.hospital_image}
                                                            alt="Hospital"
                                                            className="img-fluid rounded shadow-sm"
                                                            style={{
                                                                width: "100%",
                                                                height: "100px",
                                                                objectFit: "cover",
                                                                objectPosition: "center",
                                                            }}
                                                        />
                                                    </div>
                                                )}
                                                <p className="text-muted"> {selectedNotification.body}</p>
                                                {selectedNotification.action === "reviewHospital" && (
                                                    <>
                                                        <div className="mt-3">
                                                            <h6>Avaliação do Local:</h6>
                                                            <div className="d-flex align-items-center">
                                                                <Rate
                                                                    value={hospitalRating}
                                                                    onChange={setHospitalRating}
                                                                    onHoverChange={setHoveredHospitalRating}
                                                                    className="star-border"
                                                                />
                                                                <span
                                                                    className="ms-2">{getRating(hoveredHospitalRating || hospitalRating)}</span>
                                                            </div>
                                                        </div>
                                                        <div className="mt-3">
                        <textarea
                            className="form-control"
                            value={feedbackHospital}
                            onChange={(e) => setFeedbackHospital(e.target.value)}
                            rows="3"
                            placeholder="Escreva seu feedback aqui sobre o hospital..."
                        ></textarea>
                                                        </div>
                                                    </>
                                                )}
                                                <div className="mt-3">
                                                    <h6>Avaliação do responsável:</h6>
                                                    <div className="d-flex align-items-center">
                                                        <Rate
                                                            value={userRating}
                                                            onChange={setUserRating}
                                                            onHoverChange={setHoveredUserRating}
                                                            className="star-border"
                                                        />
                                                        <span
                                                            className="ms-2">{getRating(hoveredUserRating || userRating)}</span>
                                                    </div>
                                                </div>

                                                <div className="mt-3">
                    <textarea
                        className="form-control"
                        value={feedbackResponsavel}
                        onChange={(e) => setFeedbackResponsavel(e.target.value)}
                        rows="3"
                        placeholder="Escreva seu feedback aqui sobre o responsável..."
                    ></textarea>
                                                </div>
                                            </div>

                                            <div className="modal-footer">
                                                <button type="button" className="btn btn-secondary"
                                                        data-bs-dismiss="modal">
                                                    Fechar
                                                </button>
                                                <button type="button" className="btn btn-primary"
                                                        onClick={() => handleSaveRatings()}>
                                                    Salvar Avaliação
                                                </button>
                                            </div>
                                        </>
                                    ) : (
                                        <p>Carregando dados da notificação...</p>
                                    )}
                                </div>
                            </div>
                        </div>
                        {selectedDuty && (
                            <DutyDetailModal
                                show={modalVisible}
                                handleClose={handleModalClose}
                                eventDetails={selectedDuty}
                                onRepost={(event) => {
                                    setSelectedDuty(false);
                                    setDuty(event);
                                    setShowPlantaoRepostModal(true);
                                }}
                                onEdit={(event) => {
                                    setSelectedDuty(false);
                                    setDuty(event);
                                    setShowDutyModal(true);
                                }}
                            />
                        )}

                        {/* Modal de cadastro de plantão */}
                        {showDutyModal && (
                            <PlantaoModal
                                show={showDutyModal}
                                handleClose={handlePlantaoModalClose}
                                duty={duty}
                            />
                        )}

                        {showPlantaoRepostModal && (
                            <PlantaoRepostModal
                                show={showPlantaoRepostModal}
                                handleClose={handlePlantaoRepostModalClose}
                                duty={duty}
                            />
                        )}
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default NotificationsPage;
